// extracted by mini-css-extract-plugin
module.exports = {"image":"course-card-image_image__iJLJg"};